module.exports = __webpack_public_path__ + "img/团队设计.94d8e22a.png";